import { useId } from 'react';
import type { SVGProps } from 'react';

/**
 * Icon components exported from Figma (load-file flow).
 * Colors are normalized to `currentColor` so they inherit from CSS `color`.
 * Pass width/height/className via props at the call site.
 */
type IconProps = SVGProps<SVGSVGElement>;

export function AirIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.1673 33.3333C18.2784 33.3333 17.452 33.1111 16.6882 32.6667C15.9243 32.2222 15.3062 31.6111 14.834 30.8333C14.5284 30.2778 14.5215 29.7222 14.8132 29.1667C15.1048 28.6111 15.5562 28.3333 16.1673 28.3333C16.5284 28.3333 16.8479 28.4444 17.1257 28.6667C17.4034 28.8889 17.6534 29.1389 17.8757 29.4167C18.0145 29.6111 18.202 29.7569 18.4382 29.8542C18.6743 29.9514 18.9173 30 19.1673 30C19.6395 30 20.0354 29.8403 20.3548 29.5208C20.6743 29.2014 20.834 28.8056 20.834 28.3333C20.834 27.8611 20.6743 27.4653 20.3548 27.1458C20.0354 26.8264 19.6395 26.6667 19.1673 26.6667H5.00065C4.52843 26.6667 4.1326 26.5069 3.81315 26.1875C3.49371 25.8681 3.33398 25.4722 3.33398 25C3.33398 24.5278 3.49371 24.1319 3.81315 23.8125C4.1326 23.4931 4.52843 23.3333 5.00065 23.3333H19.1673C20.5562 23.3333 21.7368 23.8194 22.709 24.7917C23.6812 25.7639 24.1673 26.9444 24.1673 28.3333C24.1673 29.7222 23.6812 30.9028 22.709 31.875C21.7368 32.8472 20.5562 33.3333 19.1673 33.3333ZM5.00065 16.6667C4.52843 16.6667 4.1326 16.5069 3.81315 16.1875C3.49371 15.8681 3.33398 15.4722 3.33398 15C3.33398 14.5278 3.49371 14.1319 3.81315 13.8125C4.1326 13.4931 4.52843 13.3333 5.00065 13.3333H25.834C26.5284 13.3333 27.1187 13.0903 27.6048 12.6042C28.0909 12.1181 28.334 11.5278 28.334 10.8333C28.334 10.1389 28.0909 9.54861 27.6048 9.0625C27.1187 8.57639 26.5284 8.33333 25.834 8.33333C25.3895 8.33333 24.9729 8.4375 24.584 8.64583C24.1951 8.85417 23.8895 9.15278 23.6673 9.54167C23.4729 9.875 23.2368 10.1736 22.959 10.4375C22.6812 10.7014 22.3479 10.8333 21.959 10.8333C21.4034 10.8333 20.952 10.625 20.6048 10.2083C20.2576 9.79167 20.1673 9.34722 20.334 8.875C20.7229 7.70833 21.4243 6.77083 22.4382 6.0625C23.452 5.35417 24.584 5 25.834 5C27.4451 5 28.8201 5.56944 29.959 6.70833C31.0979 7.84722 31.6673 9.22222 31.6673 10.8333C31.6673 12.4444 31.0979 13.8194 29.959 14.9583C28.8201 16.0972 27.4451 16.6667 25.834 16.6667H5.00065ZM33.2507 29.5C32.6951 29.75 32.1534 29.7153 31.6257 29.3958C31.0979 29.0764 30.834 28.6111 30.834 28C30.834 27.6111 30.9659 27.2847 31.2298 27.0208C31.4937 26.7569 31.7923 26.5278 32.1257 26.3333C32.5145 26.1111 32.8132 25.8056 33.0215 25.4167C33.2298 25.0278 33.334 24.6111 33.334 24.1667C33.334 23.4722 33.0909 22.8819 32.6048 22.3958C32.1187 21.9097 31.5284 21.6667 30.834 21.6667H5.00065C4.52843 21.6667 4.1326 21.5069 3.81315 21.1875C3.49371 20.8681 3.33398 20.4722 3.33398 20C3.33398 19.5278 3.49371 19.1319 3.81315 18.8125C4.1326 18.4931 4.52843 18.3333 5.00065 18.3333H30.834C32.4451 18.3333 33.8201 18.9028 34.959 20.0417C36.0979 21.1806 36.6673 22.5556 36.6673 24.1667C36.6673 25.3333 36.3618 26.3958 35.7507 27.3542C35.1395 28.3125 34.3062 29.0278 33.2507 29.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SparkleIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.16 0L20.8002 13.5198L34.32 17.16L20.8002 20.8002L17.16 34.32L13.5198 20.8002L0 17.16L13.5198 13.5198L17.16 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SparkleSmallIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.6 0L8.00007 5.19993L13.2 6.6L8.00007 8.00007L6.6 13.2L5.19993 8.00007L0 6.6L5.19993 5.19993L6.6 0Z"
        fill="currentColor"
        fillOpacity="0.75"
      />
    </svg>
  );
}

export function MicIcon(props: IconProps): JSX.Element {
  // Unique per instance so multiple MicIcons on one page don't collide on the mask id.
  const maskId = useId();
  return (
    <svg viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3" width="10" height="14" rx="5" fill="currentColor" />
      <mask id={maskId} fill="white">
        <path d="M16 13C16 13.7879 15.7931 14.5681 15.391 15.2961C14.989 16.0241 14.3997 16.6855 13.6569 17.2426C12.914 17.7998 12.0321 18.2417 11.0615 18.5433C10.0909 18.8448 9.05057 19 8 19C6.94942 19 5.90914 18.8448 4.93853 18.5433C3.96793 18.2417 3.08601 17.7998 2.34315 17.2426C1.60028 16.6855 1.011 16.0241 0.608963 15.2961C0.206926 14.5681 -9.18442e-08 13.7879 0 13L8 13H16Z" />
      </mask>
      <path
        d="M16 13C16 13.7879 15.7931 14.5681 15.391 15.2961C14.989 16.0241 14.3997 16.6855 13.6569 17.2426C12.914 17.7998 12.0321 18.2417 11.0615 18.5433C10.0909 18.8448 9.05057 19 8 19C6.94942 19 5.90914 18.8448 4.93853 18.5433C3.96793 18.2417 3.08601 17.7998 2.34315 17.2426C1.60028 16.6855 1.011 16.0241 0.608963 15.2961C0.206926 14.5681 -9.18442e-08 13.7879 0 13L8 13H16Z"
        stroke="currentColor"
        strokeWidth="4"
        mask={`url(#${maskId})`}
      />
      <rect x="7" y="17" width="2" height="4" fill="currentColor" />
      <rect x="3" y="22" width="10" height="2" rx="1" fill="currentColor" />
    </svg>
  );
}

export function SendIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        opacity="0.55"
        d="M16.5 9.52539L0 19.0517V-0.000888824L16.5 9.52539Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ArrowIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.2822 18.2542C2.04582 18.254 1.81179 18.2073 1.59346 18.1167C1.37513 18.0261 1.17679 17.8934 1.00976 17.7261C0.842724 17.5589 0.710269 17.3603 0.619957 17.1419C0.529644 16.9234 0.483241 16.6894 0.483399 16.453C0.483556 16.2166 0.530271 15.9826 0.620875 15.7642C0.711479 15.5459 0.844199 15.3476 1.01146 15.1805C1.17871 15.0135 1.37723 14.881 1.59568 14.7907C1.81412 14.7004 2.04822 14.654 2.2846 14.6542L2.2822 18.2542ZM4.9954 16.4554L4.9954 18.2554L4.9942 18.2554L4.9954 16.4554ZM17.0398 14.6554C17.5172 14.6554 17.975 14.845 18.3126 15.1826C18.6502 15.5201 18.8398 15.978 18.8398 16.4554C18.8398 16.9328 18.6502 17.3906 18.3126 17.7282C17.975 18.0657 17.5172 18.2554 17.0398 18.2554L17.0398 14.6554ZM17.062 18.2554C16.5846 18.2554 16.1268 18.0657 15.7892 17.7282C15.4516 17.3906 15.262 16.9328 15.262 16.4554C15.262 15.978 15.4516 15.5201 15.7892 15.1826C16.1268 14.845 16.5846 14.6554 17.062 14.6554L17.062 18.2554ZM30.0622 14.6554C30.5396 14.6554 30.9974 14.845 31.335 15.1826C31.6726 15.5201 31.8622 15.978 31.8622 16.4554C31.8622 16.9328 31.6726 17.3906 31.335 17.7282C30.9974 18.0657 30.5396 18.2554 30.0622 18.2554L30.0622 14.6554ZM2.2846 14.6542L2.3296 14.6542L2.3278 18.2542L2.2822 18.2542L2.2846 14.6542ZM2.3296 14.6542L2.8636 14.6542L2.8606 18.2542L2.3278 18.2542L2.3296 14.6542ZM2.8636 14.6542L3.3964 14.6542L3.394 18.2542L2.8606 18.2542L2.8636 14.6542ZM3.3964 14.6542L3.9304 14.6548L3.9274 18.2548L3.394 18.2542L3.3964 14.6542ZM3.9304 14.6548L4.4632 14.6554L4.4608 18.2554L3.9274 18.2548L3.9304 14.6548ZM4.4632 14.6554L4.9966 14.6554L4.9942 18.2554L4.4608 18.2554L4.4632 14.6554ZM4.9954 14.6554L17.0398 14.6554L17.0398 18.2554L4.9954 18.2554L4.9954 14.6554ZM17.062 14.6554L30.0622 14.6554L30.0622 18.2554L17.062 18.2554L17.062 14.6554Z"
        fill="currentColor"
      />
      <path
        d="M15.1283 31.3667L2.42273 18.6605C2.13019 18.368 1.89813 18.0207 1.73981 17.6385C1.58149 17.2563 1.5 16.8467 1.5 16.433C1.5 16.0193 1.58149 15.6097 1.73981 15.2275C1.89813 14.8453 2.13019 14.498 2.42273 14.2055L15.1289 1.4999"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function BackIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 15 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5003 24.2975L11.194 25.625L1.61155 15.8875C1.38092 15.6496 1.25195 15.3313 1.25195 15C1.25195 14.6687 1.38092 14.3504 1.61155 14.1125L11.194 4.375L12.5003 5.70375L3.3528 15L12.5003 24.2975Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CloseIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.575 13.1879L5.92975 18.8332C5.71854 19.0444 5.44971 19.15 5.12329 19.15C4.79686 19.15 4.52804 19.0444 4.31683 18.8332C4.10561 18.622 4 18.3531 4 18.0267C4 17.7003 4.10561 17.4315 4.31683 17.2202L9.96207 11.575L4.31683 5.92975C4.10561 5.71854 4 5.44971 4 5.12329C4 4.79686 4.10561 4.52804 4.31683 4.31683C4.52804 4.10561 4.79686 4 5.12329 4C5.44971 4 5.71854 4.10561 5.92975 4.31683L11.575 9.96207L17.2202 4.31683C17.4315 4.10561 17.7003 4 18.0267 4C18.3531 4 18.622 4.10561 18.8332 4.31683C19.0444 4.52804 19.15 4.79686 19.15 5.12329C19.15 5.44971 19.0444 5.71854 18.8332 5.92975L13.1879 11.575L18.8332 17.2202C19.0444 17.4315 19.15 17.7003 19.15 18.0267C19.15 18.3531 19.0444 18.622 18.8332 18.8332C18.622 19.0444 18.3531 19.15 18.0267 19.15C17.7003 19.15 17.4315 19.0444 17.2202 18.8332L11.575 13.1879Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DimensionIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16 29.3335V16.0002M16 16.0002L27.64 9.28018M16 16.0002L4.36 9.28018M28 21.3442V10.6535C27.9992 10.1883 27.8754 9.73152 27.6413 9.32949C27.4072 8.92746 27.0709 8.59445 26.6667 8.36418L17.3333 3.02018C16.9271 2.78871 16.4676 2.66699 16 2.66699C15.5324 2.66699 15.0729 2.78871 14.6667 3.02018L5.33333 8.36418C4.508 8.83752 4 9.71085 4 10.6549V21.3455C4 22.2909 4.508 23.1629 5.33333 23.6349L14.6667 28.9788C15.0729 29.2103 15.5324 29.332 16 29.332C16.4676 29.332 16.9271 29.2103 17.3333 28.9788L26.6667 23.6349C27.492 23.1615 28 22.2882 28 21.3442Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EstimatedTimesIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.0003 2.6665C23.3643 2.6665 29.3337 8.63584 29.3337 15.9998C29.3337 23.3638 23.3643 29.3332 16.0003 29.3332C8.63633 29.3332 2.66699 23.3638 2.66699 15.9998C2.66699 8.63584 8.63633 2.6665 16.0003 2.6665ZM16.0003 5.33317C13.1713 5.33317 10.4582 6.45698 8.45785 8.45736C6.45747 10.4578 5.33366 13.1709 5.33366 15.9998C5.33366 18.8288 6.45747 21.5419 8.45785 23.5423C10.4582 25.5427 13.1713 26.6665 16.0003 26.6665C18.8293 26.6665 21.5424 25.5427 23.5428 23.5423C25.5432 21.5419 26.667 18.8288 26.667 15.9998C26.667 13.1709 25.5432 10.4578 23.5428 8.45736C21.5424 6.45698 18.8293 5.33317 16.0003 5.33317ZM16.0003 7.99984C16.3269 7.99988 16.6421 8.11978 16.8862 8.33679C17.1302 8.5538 17.2861 8.85284 17.3243 9.17717L17.3337 9.33317V15.4478L20.943 19.0572C21.1821 19.2971 21.321 19.6191 21.3313 19.9577C21.3416 20.2963 21.2227 20.6261 20.9987 20.8802C20.7746 21.1343 20.4623 21.2936 20.125 21.3257C19.7878 21.3578 19.451 21.2604 19.183 21.0532L19.0577 20.9425L15.0577 16.9425C14.8504 16.7351 14.7173 16.4652 14.679 16.1745L14.667 15.9998V9.33317C14.667 8.97955 14.8075 8.64041 15.0575 8.39036C15.3076 8.14031 15.6467 7.99984 16.0003 7.99984Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function HomeIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="currentColor" />
    </svg>
  );
}

export function PauseIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.5 14C7.1875 14 7.75 13.4375 7.75 12.75V5.25C7.75 4.5625 7.1875 4 6.5 4C5.8125 4 5.25 4.5625 5.25 5.25V12.75C5.25 13.4375 5.8125 14 6.5 14ZM11.5 14C12.1875 14 12.75 13.4375 12.75 12.75V5.25C12.75 4.5625 12.1875 4 11.5 4C10.8125 4 10.25 4.5625 10.25 5.25V12.75C10.25 13.4375 10.8125 14 11.5 14Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PreviewIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.188 14.688C16.0627 13.8127 16.5 12.75 16.5 11.5C16.5 10.25 16.0627 9.18767 15.188 8.313C14.3133 7.43833 13.2507 7.00067 12 7C10.7493 6.99933 9.687 7.437 8.813 8.313C7.939 9.189 7.50133 10.2513 7.5 11.5C7.49867 12.7487 7.93633 13.8113 8.813 14.688C9.68967 15.5647 10.752 16.002 12 16C13.248 15.998 14.3107 15.5607 15.188 14.688ZM10.088 13.412C9.56267 12.8873 9.3 12.25 9.3 11.5C9.3 10.75 9.56267 10.1127 10.088 9.588C10.6133 9.06333 11.2507 8.80067 12 8.8C12.7493 8.79933 13.387 9.062 13.913 9.588C14.439 10.114 14.7013 10.7513 14.7 11.5C14.6987 12.2487 14.4363 12.8863 13.913 13.413C13.3897 13.9397 12.752 14.202 12 14.2C11.248 14.198 10.6107 13.9357 10.088 13.413M5.35 16.963C3.35 15.6043 1.9 13.7833 1 11.5C1.9 9.21667 3.35 7.396 5.35 6.038C7.35 4.68 9.56667 4.00067 12 4C14.4333 3.99933 16.65 4.67867 18.65 6.038C20.65 7.39733 22.1 9.218 23 11.5C22.1 13.7833 20.65 15.6043 18.65 16.963C16.65 18.3217 14.4333 19.0007 12 19C9.56667 18.9993 7.35 18.3203 5.35 16.963ZM17.188 15.513C18.7627 14.521 19.9667 13.1833 20.8 11.5C19.9667 9.81667 18.7623 8.47933 17.187 7.488C15.6117 6.49667 13.8827 6.00067 12 6C10.1173 5.99933 8.38833 6.49533 6.813 7.488C5.23767 8.48067 4.03333 9.818 3.2 11.5C4.03333 13.1833 5.23767 14.521 6.813 15.513C8.38833 16.505 10.1173 17.0007 12 17C13.8827 16.9993 15.612 16.5037 17.188 15.513Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ProcessingIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 11C13.1 11 14.0417 10.6083 14.825 9.825C15.6083 9.04167 16 8.1 16 7V4H8V7C8 8.1 8.39167 9.04167 9.175 9.825C9.95833 10.6083 10.9 11 12 11ZM4 22V20H6V17C6 15.9833 6.2375 15.0292 6.7125 14.1375C7.1875 13.2458 7.85 12.5333 8.7 12C7.85 11.4667 7.1875 10.7542 6.7125 9.8625C6.2375 8.97083 6 8.01667 6 7V4H4V2H20V4H18V7C18 8.01667 17.7625 8.97083 17.2875 9.8625C16.8125 10.7542 16.15 11.4667 15.3 12C16.15 12.5333 16.8125 13.2458 17.2875 14.1375C17.7625 15.0292 18 15.9833 18 17V20H20V22H4Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function RunIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.75 26.25C6.675 26.25 5 24.575 5 22.5V7.5C5 5.425 6.675 3.75 8.75 3.75C9.4 3.75 10.05 3.925 10.6 4.25L24.675 12.3C25.65 12.85 26.25 13.9 26.25 15.025C26.25 16.15 25.65 17.175 24.675 17.75L10.6 25.8C10.025 26.125 9.4 26.3 8.75 26.3V26.25ZM8.75 6.25C8.05 6.25 7.5 6.8 7.5 7.5V22.5C7.5 23.4 8.575 24.025 9.375 23.575L23.425 15.525C23.575 15.425 23.75 15.25 23.75 14.975C23.75 14.7 23.575 14.525 23.425 14.425L9.375 6.4C9.18178 6.30041 8.96737 6.24895 8.75 6.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SettingsIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.0931 38.5C19.6665 38.5 19.2968 38.3601 18.9839 38.0802C18.6698 37.8003 18.4749 37.4513 18.3991 37.0333L17.9169 33.198C17.3315 33.0208 16.6984 32.7433 16.0176 32.3657C15.338 31.9868 14.7593 31.581 14.2814 31.1483L10.7706 32.659C10.3831 32.8301 9.98959 32.8485 9.58992 32.714C9.19025 32.5796 8.88225 32.326 8.66592 31.9532L6.68775 28.545C6.47142 28.1722 6.40786 27.7823 6.49709 27.3753C6.58631 26.9683 6.79898 26.6347 7.13509 26.3743L10.2004 24.0827C10.1454 23.7502 10.1008 23.4086 10.0666 23.0578C10.0299 22.7058 10.0116 22.3642 10.0116 22.033C10.0116 21.725 10.0299 21.4011 10.0666 21.0613C10.1008 20.7216 10.1454 20.339 10.2004 19.9137L7.13509 17.622C6.79898 17.3617 6.59242 17.0225 6.51542 16.6045C6.43842 16.1865 6.50748 15.7905 6.72259 15.4165L8.66592 12.1165C8.88225 11.7657 9.19025 11.5176 9.58992 11.3722C9.98959 11.2267 10.3831 11.2396 10.7706 11.4107L14.2466 12.8847C14.7941 12.4288 15.3869 12.0175 16.0249 11.6508C16.6605 11.2842 17.2795 11.0006 17.8821 10.8002L18.4009 6.96484C18.4755 6.54684 18.6698 6.1979 18.9839 5.91801C19.298 5.63812 19.6678 5.49879 20.0931 5.50001H23.9064C24.333 5.50001 24.7027 5.63995 25.0156 5.91984C25.3297 6.19973 25.5246 6.54867 25.6004 6.96667L26.0826 10.8387C26.7854 11.0856 27.4063 11.3685 27.9453 11.6875C28.4843 12.0065 29.0398 12.4062 29.6118 12.8865L33.2638 11.4125C33.6524 11.2414 34.0466 11.2286 34.4463 11.374C34.8459 11.5195 35.1533 11.7676 35.3684 12.1183L37.3118 15.4532C37.5281 15.8272 37.5916 16.2171 37.5024 16.6228C37.4132 17.0286 37.2005 17.3629 36.8644 17.6257L33.6598 20.02C33.76 20.3989 33.8162 20.7466 33.8284 21.0632C33.8406 21.3797 33.8468 21.6914 33.8468 21.9982C33.8468 22.283 33.8345 22.583 33.8101 22.8983C33.7869 23.2149 33.7331 23.5975 33.6488 24.046L36.7471 26.3743C37.0832 26.6347 37.302 26.9683 37.4034 27.3753C37.5049 27.7823 37.4474 28.1722 37.2311 28.545L35.2768 31.9165C35.0616 32.2905 34.7481 32.5441 34.3363 32.6773C33.9244 32.8118 33.5247 32.7935 33.1373 32.6223L29.6118 31.1117C29.041 31.592 28.4665 32.0033 27.8884 32.3455C27.3103 32.6877 26.7084 32.9597 26.0826 33.1613L25.5986 37.0315C25.524 37.4495 25.3297 37.7985 25.0156 38.0783C24.7015 38.3582 24.3318 38.4988 23.9064 38.5H20.0931ZM20.1664 36.6667H23.7524L24.4289 31.702C25.3529 31.4576 26.184 31.1221 26.9223 30.6955C27.6629 30.269 28.4158 29.6847 29.1809 28.9428L33.7551 30.8917L35.5774 27.775L31.5643 24.761C31.717 24.2391 31.8185 23.7588 31.8686 23.32C31.9175 22.8825 31.9419 22.4425 31.9419 22C31.9419 21.5356 31.9175 21.0956 31.8686 20.68C31.8197 20.2645 31.7183 19.808 31.5643 19.3105L35.6471 16.225L33.8248 13.1083L29.1461 15.07C28.5912 14.4601 27.8621 13.8887 26.9589 13.3558C26.0545 12.8242 25.1989 12.4716 24.3923 12.298L23.8331 7.33334H20.1774L19.6054 12.2632C18.6814 12.46 17.832 12.7777 17.0571 13.2165C16.2834 13.6541 15.5134 14.256 14.7471 15.0223L10.1748 13.1083L8.35242 16.225L12.3289 19.195C12.1761 19.6057 12.0692 20.0518 12.0081 20.5333C11.947 21.0149 11.9164 21.516 11.9164 22.0367C11.9164 22.5011 11.947 22.9625 12.0081 23.4208C12.0692 23.8792 12.1645 24.3253 12.2941 24.7592L8.35242 27.775L10.1748 30.8917L14.7123 28.9667C15.4321 29.6927 16.1789 30.2751 16.9526 30.7138C17.7275 31.1526 18.6001 31.4942 19.5706 31.7387L20.1664 36.6667ZM21.9503 26.5833C23.2287 26.5833 24.3122 26.1391 25.2008 25.2505C26.0893 24.362 26.5336 23.2785 26.5336 22C26.5336 20.7216 26.0893 19.6381 25.2008 18.7495C24.3122 17.861 23.2287 17.4167 21.9503 17.4167C20.6645 17.4167 19.5791 17.861 18.6943 18.7495C17.8094 19.6381 17.3669 20.7216 17.3669 22C17.3669 23.2785 17.8094 24.362 18.6943 25.2505C19.5791 26.1391 20.6645 26.5833 21.9503 26.5833Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StopIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.6667 7.33333C15.7712 7.33333 16.6667 8.22876 16.6667 9.33333V14.6667C16.6667 15.7712 15.7712 16.6667 14.6667 16.6667H9.33333C8.22876 16.6667 7.33333 15.7712 7.33333 14.6667V9.33333C7.33333 8.22876 8.22876 7.33333 9.33333 7.33333H14.6667ZM19 7C19 5.89543 18.1046 5 17 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function UpdateIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.5 2.83366L4.30313 5.2597L8.5 7.68574L12.6969 5.2597L8.5 2.83366ZM2.125 11.316V5.6847C2.125 5.42498 2.18698 5.18887 2.31094 4.97637C2.4349 4.76387 2.60903 4.59269 2.83333 4.46283L7.79167 1.61178C7.90972 1.55276 8.02483 1.50553 8.13698 1.47012C8.24913 1.4347 8.37014 1.41699 8.5 1.41699C8.62986 1.41699 8.75382 1.4347 8.87188 1.47012C8.98993 1.50553 9.10208 1.55276 9.20833 1.61178L14.1667 4.46283C14.391 4.59269 14.5651 4.76387 14.6891 4.97637C14.813 5.18887 14.875 5.42498 14.875 5.6847V7.79199C14.875 7.99269 14.8071 8.16092 14.6714 8.29668C14.5356 8.43244 14.3674 8.50033 14.1667 8.50033C13.966 8.50033 13.7977 8.43244 13.662 8.29668C13.5262 8.16092 13.4583 7.99269 13.4583 7.79199V6.44616L9.19063 8.90762C8.96632 9.03748 8.73021 9.10241 8.48229 9.10241C8.23438 9.10241 7.99826 9.03748 7.77396 8.90762L3.54167 6.44616V11.2982L7.4375 13.5649C7.54375 13.6239 7.62934 13.7066 7.69427 13.8128C7.7592 13.9191 7.79167 14.0371 7.79167 14.167C7.79167 14.4385 7.67361 14.6422 7.4375 14.7779C7.20139 14.9137 6.96528 14.9166 6.72917 14.7868L2.83333 12.5378C2.60903 12.408 2.4349 12.2368 2.31094 12.0243C2.18698 11.8118 2.125 11.5757 2.125 11.316ZM12.75 17.0003C11.7701 17.0003 10.9349 16.655 10.2443 15.9644C9.55365 15.2738 9.20833 14.4385 9.20833 13.4587C9.20833 12.4788 9.55365 11.6436 10.2443 10.9529C10.9349 10.2623 11.7701 9.91699 12.75 9.91699C13.7299 9.91699 14.5651 10.2623 15.2557 10.9529C15.9464 11.6436 16.2917 12.4788 16.2917 13.4587C16.2917 14.4385 15.9464 15.2738 15.2557 15.9644C14.5651 16.655 13.7299 17.0003 12.75 17.0003ZM12.3958 14.2378L11.3688 13.2107C11.2979 13.1399 11.2153 13.1045 11.1208 13.1045C11.0264 13.1045 10.9438 13.1399 10.8729 13.2107C10.8021 13.2816 10.7667 13.3642 10.7667 13.4587C10.7667 13.5531 10.8021 13.6357 10.8729 13.7066L12.2542 15.0878C12.325 15.1587 12.4017 15.2088 12.4844 15.2383C12.567 15.2679 12.6556 15.2826 12.75 15.2826C12.8444 15.2826 12.933 15.2679 13.0156 15.2383C13.0983 15.2088 13.175 15.1587 13.2458 15.0878L14.6271 13.7066C14.6979 13.6357 14.7333 13.5531 14.7333 13.4587C14.7333 13.3642 14.6979 13.2816 14.6271 13.2107C14.5563 13.1399 14.4736 13.1045 14.3792 13.1045C14.2847 13.1045 14.2021 13.1399 14.1313 13.2107L13.1042 14.2378V11.6878C13.1042 11.5934 13.0688 11.5107 12.9979 11.4399C12.9271 11.3691 12.8444 11.3337 12.75 11.3337C12.6556 11.3337 12.5729 11.3691 12.5021 11.4399C12.4313 11.5107 12.3958 11.5934 12.3958 11.6878V14.2378Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function UploadIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.125 21C3.42881 21 2.76113 20.7234 2.26884 20.2312C1.77656 19.7389 1.5 19.0712 1.5 18.375V14.625C1.5 14.3266 1.61853 14.0405 1.8295 13.8295C2.04048 13.6185 2.32663 13.5 2.625 13.5C2.92337 13.5 3.20952 13.6185 3.4205 13.8295C3.63147 14.0405 3.75 14.3266 3.75 14.625V18.375C3.75 18.582 3.918 18.75 4.125 18.75H19.875C19.9745 18.75 20.0698 18.7105 20.1402 18.6402C20.2105 18.5698 20.25 18.4745 20.25 18.375V14.625C20.25 14.3266 20.3685 14.0405 20.5795 13.8295C20.7905 13.6185 21.0766 13.5 21.375 13.5C21.6734 13.5 21.9595 13.6185 22.1705 13.8295C22.3815 14.0405 22.5 14.3266 22.5 14.625V18.375C22.5 19.0712 22.2234 19.7389 21.7312 20.2312C21.2389 20.7234 20.5712 21 19.875 21H4.125Z"
        fill="currentColor"
      />
      <path
        d="M17.6703 7.07963C17.7747 7.18403 17.8575 7.30797 17.914 7.44438C17.9705 7.58079 17.9996 7.72699 17.9996 7.87463C17.9996 8.02228 17.9705 8.16848 17.914 8.30488C17.8575 8.44129 17.7747 8.56523 17.6703 8.66963C17.5659 8.77403 17.4419 8.85685 17.3055 8.91335C17.1691 8.96985 17.0229 8.99893 16.8753 8.99893C16.7276 8.99893 16.5814 8.96985 16.445 8.91335C16.3086 8.85685 16.1847 8.77403 16.0803 8.66963L13.1253 5.71613V14.2496C13.1253 14.548 13.0067 14.8341 12.7958 15.0451C12.5848 15.2561 12.2986 15.3746 12.0003 15.3746C11.7019 15.3746 11.4158 15.2561 11.2048 15.0451C10.9938 14.8341 10.8753 14.548 10.8753 14.2496V5.71613L7.92028 8.66963C7.81588 8.77403 7.69193 8.85685 7.55553 8.91335C7.41912 8.96985 7.27292 8.99893 7.12528 8.99893C6.97763 8.99893 6.83143 8.96985 6.69503 8.91335C6.55862 8.85685 6.43468 8.77403 6.33028 8.66963C6.22588 8.56523 6.14306 8.44129 6.08656 8.30488C6.03006 8.16848 6.00098 8.02228 6.00098 7.87463C6.00098 7.72699 6.03006 7.58079 6.08656 7.44438C6.14306 7.30797 6.22588 7.18403 6.33028 7.07963L11.2053 2.20463C11.3096 2.10014 11.4335 2.01724 11.57 1.96067C11.7064 1.90411 11.8526 1.875 12.0003 1.875C12.148 1.875 12.2942 1.90411 12.4306 1.96067C12.567 2.01724 12.6909 2.10014 12.7953 2.20463L17.6703 7.07963Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function WorkOffsetIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.667 2.6665V5.4265C12.3203 5.72409 10.1391 6.7933 8.46644 8.46595C6.79379 10.1386 5.72458 12.3198 5.42699 14.6665H2.66699V17.3332H5.42699C5.72458 19.6799 6.79379 21.8611 8.46644 23.5337C10.1391 25.2064 12.3203 26.2756 14.667 26.5732V29.3332H17.3337V26.5732C19.6804 26.2756 21.8616 25.2064 23.5342 23.5337C25.2069 21.8611 26.2761 19.6799 26.5737 17.3332H29.3337V14.6665H26.5737C26.2761 12.3198 25.2069 10.1386 23.5342 8.46595C21.8616 6.7933 19.6804 5.72409 17.3337 5.4265V2.6665M14.667 8.1065V10.6665H17.3337V8.11984C20.667 8.6665 23.3337 11.3332 23.8937 14.6665H21.3337V17.3332H23.8803C23.3337 20.6665 20.667 23.3332 17.3337 23.8932V21.3332H14.667V23.8798C11.3337 23.3332 8.66699 20.6665 8.10699 17.3332H10.667V14.6665H8.12033C8.66699 11.3332 11.3337 8.6665 14.667 8.1065ZM16.0003 14.6665C15.6467 14.6665 15.3076 14.807 15.0575 15.057C14.8075 15.3071 14.667 15.6462 14.667 15.9998C14.667 16.3535 14.8075 16.6926 15.0575 16.9426C15.3076 17.1927 15.6467 17.3332 16.0003 17.3332C16.3539 17.3332 16.6931 17.1927 16.9431 16.9426C17.1932 16.6926 17.3337 16.3535 17.3337 15.9998C17.3337 15.6462 17.1932 15.3071 16.9431 15.057C16.6931 14.807 16.3539 14.6665 16.0003 14.6665Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MinusIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line
        x1="5"
        y1="12"
        x2="19"
        y2="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function PlusIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line
        x1="12"
        y1="5"
        x2="12"
        y2="19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="5"
        y1="12"
        x2="19"
        y2="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ChevronLeftIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

export function ChevronRightIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

export function ChevronDownIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  );
}

export function SimulateIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
      <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
      <line x1="12" y1="22.08" x2="12" y2="12" />
    </svg>
  );
}

export function DialpadIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Row 1 */}
      <circle cx="5" cy="5" r="2.5" />
      <circle cx="12" cy="5" r="2.5" />
      <circle cx="19" cy="5" r="2.5" />
      {/* Row 2 */}
      <circle cx="5" cy="12" r="2.5" />
      <circle cx="12" cy="12" r="2.5" />
      <circle cx="19" cy="12" r="2.5" />
      {/* Row 3 — center only */}
      <circle cx="12" cy="19" r="2.5" />
    </svg>
  );
}

export function ArrowGoIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.5 8.14808H15.5741M10.3889 13.3333L15.5741 8.14808L10.3889 2.96289"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NumpadSvgIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 52 43" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M49.2266 0C50.7582 0 52 1.2996 52 2.90234V25.3926C52 26.9953 50.7582 28.2949 49.2266 28.2949H2.77344C1.24177 28.2949 0 26.9953 0 25.3926V2.90234C0 1.2996 1.24177 0 2.77344 0H49.2266ZM3.27832 2.65234C2.90373 2.65234 2.59961 2.96486 2.59961 3.34961V24.9453C2.59961 25.3301 2.90373 25.6426 3.27832 25.6426H48.7217C49.0963 25.6426 49.4004 25.3301 49.4004 24.9453V3.34961C49.4004 2.96486 49.0963 2.65234 48.7217 2.65234H3.27832ZM9.5332 22.1055H6.06641V18.5684H9.5332V22.1055ZM39.8662 22.1055H12.1338V18.5684H39.8662V22.1055ZM45.9336 22.1055H42.4668V18.5684H45.9336V22.1055ZM9.5332 15.916H6.06641V12.3789H9.5332V15.916ZM15.5996 15.916H12.1338V12.3789H15.5996V15.916ZM21.667 15.916H18.2002V12.3789H21.667V15.916ZM27.7334 15.916H24.2666V12.3789H27.7334V15.916ZM33.7998 15.916H30.333V12.3789H33.7998V15.916ZM39.8662 15.916H36.4004V12.3789H39.8662V15.916ZM45.9336 15.916H42.4668V12.3789H45.9336V15.916ZM9.5332 9.72656H6.06641V6.18945H9.5332V9.72656ZM15.5996 9.72656H12.1338V6.18945H15.5996V9.72656ZM21.667 9.72656H18.2002V6.18945H21.667V9.72656ZM27.7334 9.72656H24.2666V6.18945H27.7334V9.72656ZM33.7998 9.72656H30.333V6.18945H33.7998V9.72656ZM39.8662 9.72656H36.4004V6.18945H39.8662V9.72656ZM45.9336 9.72656H42.4668V6.18945H45.9336V9.72656Z"
        fill="currentColor"
      />
      <path d="M18.6328 35.8105L25.9995 42L33.3661 35.8105" fill="currentColor" />
      <path
        d="M18.6328 35.8105L25.9995 42L33.3661 35.8105"
        stroke="#5D5D86"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 48 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.4773 27.488L28.4107 20.5547L35.344 27.488L37.2293 25.6L30.296 18.6667L37.2293 11.7333L35.344 9.84533L28.4107 16.7787L21.4773 9.84533L19.5893 11.7333L26.5227 18.6667L19.5893 25.6L21.4773 27.488ZM16.4613 37.3333C15.7804 37.3333 15.1342 37.1858 14.5227 36.8907C13.9111 36.5956 13.4089 36.1858 13.016 35.6613L0 18.6667L13.0133 1.672C13.4098 1.14933 13.9129 0.740444 14.5227 0.445333C15.1324 0.150222 15.7787 0.00177778 16.4613 0H43.6933C44.8773 0 45.8907 0.422222 46.7333 1.26667C47.576 2.11111 47.9982 3.12444 48 4.30667V33.0267C48 34.2107 47.5778 35.224 46.7333 36.0667C45.8889 36.9093 44.8756 37.3316 43.6933 37.3333H16.4613ZM3.33333 18.6667L15.128 34.0533C15.2987 34.256 15.4951 34.4089 15.7173 34.512C15.9396 34.6151 16.1876 34.6667 16.4613 34.6667H43.6933C44.1716 34.6667 44.5644 34.5129 44.872 34.2053C45.1796 33.8978 45.3333 33.504 45.3333 33.024V4.30933C45.3333 3.82933 45.1796 3.43555 44.872 3.128C44.5644 2.82044 44.1716 2.66667 43.6933 2.66667H16.4613C16.1876 2.66667 15.9396 2.71822 15.7173 2.82133C15.4951 2.92444 15.2987 3.07822 15.128 3.28267L3.33333 18.6667Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ToolT03Icon(props: IconProps): JSX.Element {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#tool-t03-clip)">
        <g opacity="0.22" filter="url(#tool-t03-blur)">
          <path
            d="M20 19.9219C24.099 19.9219 27.4219 16.2492 27.4219 11.7188C27.4219 7.18829 24.099 3.51562 20 3.51562C15.901 3.51562 12.5781 7.18829 12.5781 11.7188C12.5781 16.2492 15.901 19.9219 20 19.9219Z"
            fill="#9D46FF"
          />
        </g>
        <path
          d="M25.7031 5H14.2969C13.5202 5 12.8906 5.6296 12.8906 6.40625V8.125C12.8906 8.90165 13.5202 9.53125 14.2969 9.53125H25.7031C26.4798 9.53125 27.1094 8.90165 27.1094 8.125V6.40625C27.1094 5.6296 26.4798 5 25.7031 5Z"
          fill="url(#tool-t03-g0)"
          stroke="#E6EAF5"
          strokeOpacity="0.7"
          strokeWidth="3"
        />
        <path d="M14.2188 7.1875H25.7812V15.7812H14.2188V7.1875Z" fill="url(#tool-t03-g1)" />
        <path d="M14.2188 7.1875H17.9688V15.7812H14.2188V7.1875Z" fill="#697386" />
        <path d="M22.0312 7.1875H25.7812V15.7812H22.0312V7.1875Z" fill="#333A49" />
        <path d="M20 7.1875V15.7812" stroke="#E6EAF5" strokeOpacity="0.45" strokeWidth="4" />
        <path
          d="M15.2344 15.7812H24.7656L22.8125 22.0312H17.1875L15.2344 15.7812Z"
          fill="url(#tool-t03-g2)"
          stroke="#E6EAF5"
          strokeOpacity="0.6"
          strokeWidth="2"
        />
        <path
          d="M21.7188 21.0938H18.2812C17.8498 21.0938 17.5 21.4435 17.5 21.875V24.375C17.5 24.8065 17.8498 25.1562 18.2812 25.1562H21.7188C22.1502 25.1562 22.5 24.8065 22.5 24.375V21.875C22.5 21.4435 22.1502 21.0938 21.7188 21.0938Z"
          fill="#3E4656"
          stroke="#E6EAF5"
          strokeOpacity="0.55"
          strokeWidth="2"
        />
        <path
          d="M18.5938 21.4844L18.125 24.8438M20 21.4844L19.5312 24.8438M21.4062 21.4844L20.9375 24.8438"
          stroke="#E6EAF5"
          strokeOpacity="0.45"
          strokeWidth="2"
        />
        <path d="M19.2188 24.8438H20.7812V32.1875H19.2188V24.8438Z" fill="url(#tool-t03-g3)" />
        <path
          d="M19.2188 32.1875H20.7812L20 36.0938L19.2188 32.1875Z"
          fill="#E6EAF5"
          stroke="#E6EAF5"
          strokeOpacity="0.7"
          strokeWidth="2"
        />
        <path
          d="M20 32.1875V36.0938M19.375 32.9688L20.1562 35.5469M20.625 32.9688L19.8438 35.5469"
          stroke="#333A49"
          strokeOpacity="0.75"
          strokeWidth="2"
        />
        <path
          d="M12.9688 10.1562V15.1562M27.0312 10.1562V15.1562"
          stroke="#9D46FF"
          strokeWidth="5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <filter
          id="tool-t03-blur"
          x="-35.4219"
          y="-44.4844"
          width="110.844"
          height="112.406"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_4166_31363" />
        </filter>
        <linearGradient
          id="tool-t03-g0"
          x1="12.5"
          y1="4.6875"
          x2="27.3437"
          y2="35.9375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF2FA" />
          <stop offset="0.45" stopColor="#8992A3" />
          <stop offset="1" stopColor="#303746" />
        </linearGradient>
        <linearGradient
          id="tool-t03-g1"
          x1="14.0625"
          y1="7.03125"
          x2="25.7813"
          y2="16.4062"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#737D8F" />
          <stop offset="1" stopColor="#262D3A" />
        </linearGradient>
        <linearGradient
          id="tool-t03-g2"
          x1="12.5"
          y1="4.6875"
          x2="27.3437"
          y2="35.9375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF2FA" />
          <stop offset="0.45" stopColor="#8992A3" />
          <stop offset="1" stopColor="#303746" />
        </linearGradient>
        <linearGradient
          id="tool-t03-g3"
          x1="12.5"
          y1="4.6875"
          x2="27.3438"
          y2="35.9375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF2FA" />
          <stop offset="0.45" stopColor="#8992A3" />
          <stop offset="1" stopColor="#303746" />
        </linearGradient>
        <clipPath id="tool-t03-clip">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

// Offset-status icons — carry their own fixed colors (teal check / amber
// warning), matching the Figma design, so no currentColor tinting is needed.
export function StatusCheckIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="18" cy="18" r="18" fill="#05FFBE" fillOpacity="0.12" />
      <circle cx="18" cy="18" r="15" fill="#05FFBE" fillOpacity="0.12" />
      <path
        d="M26 13L16 23L11 18"
        stroke="#05FFBE"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StatusNotReadyIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="36" height="36" rx="18" fill="#303746" />
      <path
        d="M18.0007 6.3335C11.5607 6.3335 6.33398 11.5602 6.33398 18.0002C6.33398 24.4402 11.5607 29.6668 18.0007 29.6668C24.4407 29.6668 29.6673 24.4402 29.6673 18.0002C29.6673 11.5602 24.4407 6.3335 18.0007 6.3335ZM19.1673 23.8335H16.834V21.5002H19.1673V23.8335ZM19.1673 19.1668H16.834V12.1668H19.1673V19.1668Z"
        fill="#FFD21E"
      />
    </svg>
  );
}

export function ResetIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** A rotary axis glyph (letter + dashed tilt planes). Fixed multi-color decoration. */
export function AAxisIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.5991 23.1597H18.2951L17.2711 26.2637H15.9591L19.7031 15.0637H21.2711L25.0471 26.2637H23.6551L22.5991 23.1597ZM18.7111 22.0077H22.2311L20.5831 16.7437H20.3911L18.7111 22.0077Z"
        fill="white"
      />
      <path
        d="M32.4747 3.39047L32.232 3.82763V3.82763L32.4747 3.39047ZM41.2933 12.1095L41.1937 6.33684L36.2443 9.30944L41.2933 12.1095ZM20.4108 0.517664L20.3912 0.018048L20.4108 0.517664ZM0.0475669 13.4962C-0.0699858 13.746 0.0372801 14.0439 0.287152 14.1614C0.537024 14.279 0.834881 14.1717 0.952433 13.9218L0.5 13.709L0.0475669 13.4962ZM8.60889 4.32625L8.88504 4.74307V4.74307L8.60889 4.32625ZM0.5 13.709L0.952433 13.9218C1.09791 13.6126 1.2502 13.3072 1.40912 13.0058L0.966837 12.7726L0.524551 12.5394C0.358561 12.8542 0.199507 13.1732 0.0475669 13.4962L0.5 13.709ZM2.02571 10.9684L2.44497 11.2408C2.81724 10.6679 3.21503 10.1128 3.63695 9.57716L3.24418 9.26777L2.8514 8.95837C2.41072 9.5178 1.99525 10.0975 1.60644 10.6959L2.02571 10.9684ZM4.61211 7.68494L4.97515 8.02875C5.44399 7.53367 5.93558 7.05965 6.44851 6.60831L6.11821 6.23294L5.78791 5.85757C5.25218 6.32897 4.73875 6.82406 4.24907 7.34114L4.61211 7.68494ZM7.74999 4.92383L8.04481 5.32767C8.32002 5.12675 8.60015 4.93181 8.88504 4.74307L8.60889 4.32625L8.33273 3.90943C8.03519 4.10656 7.74261 4.31015 7.45516 4.52L7.74999 4.92383ZM8.60889 4.32625L8.88504 4.74307C9.16993 4.55433 9.45866 4.37237 9.75098 4.19729L9.49407 3.76834L9.23716 3.33939C8.93184 3.52226 8.63028 3.7123 8.33273 3.90943L8.60889 4.32625ZM11.3358 2.77616L11.5527 3.22668C12.1683 2.93033 12.7965 2.66248 13.4352 2.42378L13.2601 1.95542L13.0851 1.48706C12.418 1.73637 11.7619 2.01612 11.1189 2.32564L11.3358 2.77616ZM15.2511 1.31293L15.3828 1.79526C16.0406 1.61558 16.7068 1.46571 17.3795 1.34629L17.2922 0.85399L17.2048 0.361686C16.5022 0.486405 15.8063 0.64294 15.1193 0.830605L15.2511 1.31293ZM19.3665 0.582426L19.4087 1.08063C19.7483 1.05181 20.0889 1.03067 20.4304 1.01728L20.4108 0.517664L20.3912 0.018048C20.0345 0.0320323 19.6788 0.0541168 19.3242 0.084218L19.3665 0.582426ZM20.4108 0.517664L20.4304 1.01728C20.7719 1.00389 21.1131 0.9983 21.4538 1.00045L21.457 0.500456L21.4601 0.000466377C21.1042 -0.00177574 20.7478 0.00406376 20.3912 0.018048L20.4108 0.517664ZM23.5462 0.608769L23.4976 1.1064C24.1776 1.17278 24.8535 1.27002 25.5233 1.39765L25.6169 0.906485L25.7105 0.415322C25.0109 0.282023 24.305 0.180455 23.5947 0.111134L23.5462 0.608769ZM27.652 1.39111L27.5142 1.87174C28.1696 2.0597 28.8169 2.27754 29.4538 2.52477L29.6347 2.05865L29.8157 1.59254C29.1504 1.33431 28.4744 1.10679 27.7899 0.910484L27.652 1.39111ZM31.5485 2.90358L31.326 3.35133C31.6311 3.50299 31.9332 3.66177 32.232 3.82763L32.4747 3.39047L32.7173 2.9533C32.4053 2.78008 32.0897 2.61423 31.771 2.45583L31.5485 2.90358ZM32.4747 3.39047L32.232 3.82763C32.5308 3.99349 32.8253 4.16589 33.1154 4.34464L33.3777 3.91897L33.64 3.49329C33.337 3.30659 33.0294 3.12653 32.7173 2.9533L32.4747 3.39047ZM35.107 5.09628L34.8071 5.49636C35.3538 5.90616 35.881 6.34023 36.3871 6.79707L36.7222 6.4259L37.0572 6.05472C36.5285 5.57757 35.9779 5.12421 35.4069 4.6962L35.107 5.09628ZM38.2098 7.89675L37.8425 8.23596C38.305 8.73691 38.7451 9.25913 39.1611 9.80113L39.5577 9.49671L39.9543 9.19229C39.5199 8.6262 39.0603 8.08076 38.5772 7.55755L38.2098 7.89675Z"
        fill="#3C3C54"
      />
    </svg>
  );
}

/** C rotary axis glyph (letter + dashed spin rings). Fixed multi-color decoration. */
export function CAxisIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 41 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.3221 29.5C6.78635 29.8422 0.5 31.0102 0.5 32.3985C0.5 34.0553 9.4543 35.3985 20.5 35.3985C31.5457 35.3985 40.5 34.0553 40.5 32.3985C40.5 31.0829 34.8549 29.9652 27 29.5605"
        stroke="#3C3C54"
        strokeDasharray="2 2"
      />
      <path
        d="M25.6779 6.39844C34.2136 6.05622 40.5 4.8882 40.5 3.49995C40.5 1.8431 31.5457 0.499953 20.5 0.499954C9.4543 0.499955 0.5 1.8431 0.5 3.49996C0.5 4.8155 6.14511 5.93327 14 6.33796"
        stroke="#3C3C54"
        strokeDasharray="2 2"
      />
      <path
        d="M23.0311 13.2797C22.8498 13.205 22.6471 13.1517 22.4231 13.1197C22.2098 13.077 21.9485 13.0557 21.6391 13.0557C21.2018 13.0557 20.7698 13.1357 20.3431 13.2957C19.9271 13.4557 19.5538 13.717 19.2231 14.0797C18.9031 14.4423 18.6418 14.917 18.4391 15.5037C18.2471 16.0903 18.1511 16.8103 18.1511 17.6637C18.1511 18.4317 18.2365 19.1037 18.4071 19.6797C18.5885 20.2557 18.8338 20.7357 19.1431 21.1197C19.4631 21.5037 19.8418 21.7917 20.2791 21.9837C20.7271 22.1757 21.2231 22.2717 21.7671 22.2717C22.0445 22.2717 22.3005 22.2503 22.5351 22.2077C22.7805 22.1543 23.0045 22.085 23.2071 21.9997V20.3997H24.3911V22.5597L24.4071 22.5917C24.0871 22.837 23.6818 23.045 23.1911 23.2157C22.7005 23.3757 22.1031 23.4557 21.3991 23.4557C20.7271 23.4557 20.1031 23.3437 19.5271 23.1197C18.9618 22.885 18.4711 22.533 18.0551 22.0637C17.6391 21.5943 17.3138 20.997 17.0791 20.2717C16.8551 19.5357 16.7431 18.6663 16.7431 17.6637C16.7431 16.6183 16.8711 15.733 17.1271 15.0077C17.3831 14.2717 17.7298 13.6743 18.1671 13.2157C18.6045 12.7463 19.1111 12.405 19.6871 12.1917C20.2738 11.9783 20.8978 11.8717 21.5591 11.8717C21.9218 11.8717 22.2365 11.8877 22.5031 11.9197C22.7698 11.941 23.0045 11.9783 23.2071 12.0317C23.4098 12.0743 23.5858 12.133 23.7351 12.2077C23.8951 12.2823 24.0498 12.3677 24.1991 12.4637H24.2151V14.9917H23.0311V13.2797Z"
        fill="white"
      />
      <path
        d="M20.2922 28.8735L15.3374 31.8372L15.2482 26.0644L20.2922 28.8735ZM15.5 28.5713L15.5834 28.0783C15.9699 28.1437 16.3582 28.199 16.748 28.2441L16.6905 28.7408L16.633 29.2375C16.2258 29.1903 15.8203 29.1326 15.4166 29.0643L15.5 28.5713Z"
        fill="#3C3C54"
      />
      <path
        d="M20.4992 6.79443L25.2372 3.49533L25.7253 9.24816L20.4992 6.79443ZM25.3008 6.76465L25.2517 7.26223C24.8616 7.22373 24.4704 7.19541 24.0784 7.17733L24.1014 6.67786L24.1245 6.17839C24.5339 6.19728 24.9425 6.22686 25.3499 6.26707L25.3008 6.76465Z"
        fill="#3C3C54"
      />
    </svg>
  );
}

/** Spindle temperature thermometer. Fixed brand color. */
export function TempIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.8635 13.4003V4.93931C14.8574 4.17931 14.5562 3.45142 14.0235 2.90931C13.7323 2.62079 13.3824 2.39826 12.9977 2.25678C12.6129 2.1153 12.2023 2.05819 11.7935 2.08931C11.0537 2.16221 10.3687 2.51173 9.87551 3.06796C9.38233 3.62418 9.11732 4.3461 9.1335 5.08931L9.1435 13.3693C8.41132 13.9192 7.85351 14.6689 7.53707 15.5282C7.22064 16.3875 7.15905 17.3198 7.35971 18.2133C7.56036 19.1067 8.01473 19.9232 8.66821 20.5647C9.32169 21.2061 10.1465 21.6453 11.0435 21.8293C11.3566 21.8895 11.6747 21.9197 11.9935 21.9193C13.2542 21.9193 14.4634 21.4192 15.3558 20.5287C16.2482 19.6382 16.7509 18.43 16.7535 17.1693C16.7553 16.437 16.5852 15.7145 16.257 15.0599C15.9287 14.4053 15.4514 13.8369 14.8635 13.4003ZM14.3835 20.0603C13.9493 20.416 13.4413 20.6706 12.8965 20.8055C12.3516 20.9405 11.7835 20.9523 11.2335 20.8403C10.5035 20.6949 9.83436 20.3328 9.31342 19.8011C8.79249 19.2695 8.44401 18.5931 8.3135 17.8603C8.1841 17.1731 8.24943 16.4634 8.50212 15.8113C8.75481 15.1593 9.1848 14.5909 9.7435 14.1703C9.86411 14.0813 9.9622 13.9653 10.0299 13.8316C10.0976 13.6979 10.1331 13.5502 10.1335 13.4003V5.08931C10.1224 4.60074 10.2934 4.12551 10.6131 3.7559C10.9328 3.3863 11.3784 3.14872 11.8635 3.08931C11.9097 3.08129 11.9566 3.07794 12.0035 3.07931C12.4952 3.08451 12.9653 3.28215 13.313 3.62984C13.6607 3.97754 13.8583 4.44762 13.8635 4.93931V13.4003C13.8639 13.5502 13.8994 13.6979 13.9671 13.8316C14.0348 13.9653 14.1329 14.0813 14.2535 14.1703C14.708 14.5104 15.0791 14.9495 15.3388 15.4542C15.5985 15.959 15.74 16.5162 15.7525 17.0837C15.765 17.6512 15.6483 18.2141 15.4111 18.7298C15.1739 19.2455 14.8225 19.7005 14.3835 20.0603Z"
        fill="#B073FF"
      />
      <path
        d="M13.8933 17.1694C13.8933 17.6707 13.6942 18.1514 13.3397 18.5058C12.9853 18.8603 12.5046 19.0594 12.0033 19.0594C11.5021 19.0594 11.0213 18.8603 10.6669 18.5058C10.3124 18.1514 10.1133 17.6707 10.1133 17.1694C10.111 16.7562 10.2464 16.3539 10.4981 16.0262C10.7498 15.6984 11.1035 15.4638 11.5033 15.3594V5.40039C11.5033 5.26778 11.556 5.14061 11.6498 5.04684C11.7435 4.95307 11.8707 4.90039 12.0033 4.90039C12.1359 4.90039 12.2631 4.95307 12.3569 5.04684C12.4506 5.14061 12.5033 5.26778 12.5033 5.40039V15.3604C12.9021 15.4663 13.2547 15.7012 13.5061 16.0284C13.7575 16.3556 13.8937 16.7568 13.8933 17.1694Z"
        fill="#B073FF"
      />
    </svg>
  );
}

/** Spindle start (play) triangle. Fixed brand color. */
export function PlayIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.606162 15.8526C0.784391 15.9511 0.985948 16.0019 1.19057 15.9999C1.39519 15.9979 1.59567 15.9432 1.77186 15.8411L13.4288 8.98525C13.7785 8.77958 14 8.4025 14 8.00258C14 7.60265 13.7902 7.22558 13.4288 7.0199L1.77186 0.164019C1.59473 0.0587021 1.39194 0.00206598 1.18478 5.54578e-05C0.97762 -0.00195507 0.773729 0.0507344 0.594505 0.152593C0.233139 0.358269 0 0.735343 0 1.1467V14.8585C0 15.2698 0.221482 15.6469 0.594505 15.8526H0.606162ZM2.34305 3.16918L10.5729 8.00258L2.34305 12.836V3.16918Z"
        fill="#05FFBE"
      />
    </svg>
  );
}

/** Spindle stop (square) outline. Fixed brand color. */
export function SpindleStopIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2V14C15 14.2652 14.8946 14.5196 14.7071 14.7071C14.5196 14.8946 14.2652 15 14 15H2C1.73478 15 1.48043 14.8946 1.29289 14.7071C1.10536 14.5196 1 14.2652 1 14V2Z"
        stroke="#F04248"
        strokeWidth="2"
      />
    </svg>
  );
}

export function CallToolIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 15.11L4.94429 10.0557L5.95571 9.02714L9.28571 12.3571V0H10.7143V12.3571L14.0429 9.02857L15.0557 10.0557L10 15.11ZM2.30857 20C1.65048 20 1.10143 19.78 0.661428 19.34C0.221428 18.9 0.000952381 18.3505 0 17.6914V14.23H1.42857V17.6914C1.42857 17.9114 1.52 18.1133 1.70286 18.2971C1.88571 18.481 2.08714 18.5724 2.30714 18.5714H17.6929C17.9119 18.5714 18.1133 18.48 18.2971 18.2971C18.481 18.1143 18.5724 17.9124 18.5714 17.6914V14.23H20V17.6914C20 18.3495 19.78 18.8986 19.34 19.3386C18.9 19.7786 18.3505 19.999 17.6914 20H2.30857Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function GetOffsetIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 0C10.1768 0 10.3464 0.0702379 10.4714 0.195262C10.5964 0.320286 10.6667 0.489856 10.6667 0.666667V2.41067C12.4143 2.59865 14.0402 3.39501 15.2601 4.66048C16.48 5.92595 17.2162 7.57999 17.34 9.33333H19.3333C19.5101 9.33333 19.6797 9.40357 19.8047 9.5286C19.9298 9.65362 20 9.82319 20 10C20 10.1768 19.9298 10.3464 19.8047 10.4714C19.6797 10.5964 19.5101 10.6667 19.3333 10.6667H17.316C17.1331 12.3675 16.3738 13.9546 15.1642 15.1642C13.9546 16.3738 12.3675 17.1331 10.6667 17.316V19.3333C10.6667 19.5101 10.5964 19.6797 10.4714 19.8047C10.3464 19.9298 10.1768 20 10 20C9.82319 20 9.65362 19.9298 9.5286 19.8047C9.40357 19.6797 9.33333 19.5101 9.33333 19.3333V17.3387C7.58043 17.2146 5.92687 16.4785 4.6617 15.2589C3.39653 14.0393 2.60023 12.4138 2.412 10.6667H0.666667C0.489856 10.6667 0.320286 10.5964 0.195262 10.4714C0.0702379 10.3464 0 10.1768 0 10C0 9.82319 0.0702379 9.65362 0.195262 9.5286C0.320286 9.40357 0.489856 9.33333 0.666667 9.33333H2.388C2.51545 7.53342 3.28811 5.83995 4.56403 4.56403C5.83995 3.28811 7.53342 2.51545 9.33333 2.388V0.666667C9.33333 0.489856 9.40357 0.320286 9.5286 0.195262C9.65362 0.0702379 9.82319 0 10 0ZM9.33333 3.656C7.86952 3.78065 6.49693 4.41887 5.45823 5.45781C4.41954 6.49675 3.78164 7.86949 3.65733 9.33333H7.33333C7.51014 9.33333 7.67971 9.40357 7.80474 9.5286C7.92976 9.65362 8 9.82319 8 10C8 10.1768 7.92976 10.3464 7.80474 10.4714C7.67971 10.5964 7.51014 10.6667 7.33333 10.6667H3.68667C3.86968 12.0765 4.52965 13.3813 5.55689 14.3642C6.58412 15.347 7.91677 15.9487 9.33333 16.0693V12.6667C9.33333 12.4899 9.40357 12.3203 9.5286 12.1953C9.65362 12.0702 9.82319 12 10 12C10.1768 12 10.3464 12.0702 10.4714 12.1953C10.5964 12.3203 10.6667 12.4899 10.6667 12.6667V16.04C12.0298 15.8631 13.2961 15.24 14.2681 14.2681C15.24 13.2961 15.8631 12.0298 16.04 10.6667H12.6667C12.4899 10.6667 12.3203 10.5964 12.1953 10.4714C12.0702 10.3464 12 10.1768 12 10C12 9.82319 12.0702 9.65362 12.1953 9.5286C12.3203 9.40357 12.4899 9.33333 12.6667 9.33333H16.0693C15.9487 7.91677 15.347 6.58412 14.3642 5.55689C13.3813 4.52965 12.0765 3.86968 10.6667 3.68667V7.33333C10.6667 7.51014 10.5964 7.67971 10.4714 7.80474C10.3464 7.92976 10.1768 8 10 8C9.82319 8 9.65362 7.92976 9.5286 7.80474C9.40357 7.67971 9.33333 7.51014 9.33333 7.33333V3.656Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ToolReleaseIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.73143 20C1.25143 20 0.842857 19.8252 0.505714 19.4756C0.168572 19.1259 0 18.7026 0 18.2056V8.46111C0 7.96482 0.168572 7.54148 0.505714 7.19111C0.842857 6.84148 1.25143 6.66667 1.73143 6.66667H3.21429V4.44444C3.21429 3.20667 3.63036 2.15667 4.4625 1.29444C5.29393 0.431481 6.30643 0 7.5 0C8.69357 0 9.70643 0.431481 10.5386 1.29444C11.3707 2.15741 11.7864 3.20741 11.7857 4.44444V6.66667H13.2696C13.7482 6.66667 14.1564 6.84148 14.4943 7.19111C14.8314 7.54074 15 7.96445 15 8.46222V18.2056C15 18.7019 14.8314 19.1252 14.4943 19.4756C14.1571 19.8252 13.7489 20 13.2696 20H1.73143ZM1.73143 18.8889H13.2696C13.4618 18.8889 13.6196 18.8248 13.7432 18.6967C13.8668 18.5685 13.9286 18.4048 13.9286 18.2056V8.46111C13.9286 8.26185 13.8668 8.09815 13.7432 7.97C13.6196 7.84185 13.4618 7.77778 13.2696 7.77778H1.73036C1.53821 7.77778 1.38036 7.84185 1.25679 7.97C1.13321 8.09815 1.07143 8.26222 1.07143 8.46222V18.2056C1.07143 18.4048 1.13321 18.5685 1.25679 18.6967C1.38036 18.8248 1.53857 18.8889 1.73143 18.8889ZM8.64214 14.5178C8.95214 14.197 9.10714 13.8022 9.10714 13.3333C9.10714 12.8644 8.95214 12.4696 8.64214 12.1489C8.33214 11.8281 7.95143 11.6674 7.5 11.6667C7.04857 11.6659 6.66786 11.8267 6.35786 12.1489C6.04786 12.4696 5.89286 12.8644 5.89286 13.3333C5.89286 13.8022 6.04786 14.197 6.35786 14.5178C6.66714 14.8393 7.04786 15 7.5 15C7.95214 15 8.33286 14.8393 8.64214 14.5178ZM4.28571 6.66667H10.7143V4.44444C10.7143 3.51852 10.4018 2.73148 9.77679 2.08333C9.15179 1.43519 8.39286 1.11111 7.5 1.11111C6.60714 1.11111 5.84821 1.43519 5.22321 2.08333C4.59821 2.73148 4.28571 3.51852 4.28571 4.44444V6.66667Z"
        fill="currentColor"
      />
    </svg>
  );
}

// Measurement-method icons — colors normalized to currentColor so they inherit
// from the tab/button `color`.
export function CameraIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 20C17.0711 20 18.75 18.3211 18.75 16.25C18.75 14.1789 17.0711 12.5 15 12.5C12.9289 12.5 11.25 14.1789 11.25 16.25C11.25 18.3211 12.9289 20 15 20Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M12.2225 26.2501H17.7775C21.6788 26.2501 23.63 26.2501 25.0312 25.3313C25.636 24.9352 26.1568 24.4238 26.5637 23.8263C27.5 22.4513 27.5 20.5351 27.5 16.7051C27.5 12.8751 27.5 10.9588 26.5637 9.58381C26.1568 8.9863 25.636 8.47488 25.0312 8.07881C24.1312 7.48756 23.0037 7.27631 21.2775 7.20131C20.4537 7.20131 19.745 6.58881 19.5837 5.79506C19.4605 5.21364 19.1403 4.6926 18.6773 4.32C18.2143 3.94739 17.6368 3.74607 17.0425 3.75006H12.9575C11.7225 3.75006 10.6588 4.60631 10.4163 5.79506C10.255 6.58881 9.54625 7.20131 8.7225 7.20131C6.9975 7.27631 5.87 7.48881 4.96875 8.07881C4.36442 8.47501 3.84409 8.98642 3.4375 9.58381C2.5 10.9588 2.5 12.8738 2.5 16.7051C2.5 20.5363 2.5 22.4501 3.43625 23.8263C3.84125 24.4213 4.36125 24.9326 4.96875 25.3313C6.37 26.2501 8.32125 26.2501 12.2225 26.2501Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M23.75 12.5H22.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function EntryIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.125 22.875H8.36025L20.3955 10.8398L19.1602 9.60451L7.125 21.6398V22.875ZM6 24V21.165L20.8275 6.32402C20.9438 6.22127 21.0713 6.14177 21.21 6.08552C21.3488 6.02927 21.4939 6.00077 21.6454 6.00002C21.7969 5.99927 21.9431 6.02327 22.0841 6.07202C22.2266 6.11927 22.3579 6.20477 22.4779 6.32852L23.6783 7.53677C23.802 7.65602 23.8868 7.78727 23.9325 7.93052C23.9775 8.07302 24 8.21552 24 8.35802C24 8.51101 23.9745 8.65726 23.9235 8.79676C23.8717 8.93551 23.79 9.06264 23.6783 9.17814L8.83388 24H6ZM19.7678 10.2323L19.1602 9.60451L20.3955 10.8398L19.7678 10.2323Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function StartIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.25 10.2305C20.2499 10.8078 20.2499 12.2508 19.25 12.8281L2.75 22.3545C1.75003 22.9318 0.500062 22.2103 0.499999 21.0557L0.5 2.00293C0.500058 0.920615 1.5984 0.218556 2.55957 0.610351L2.75 0.704101L19.25 10.2305Z"
        stroke="currentColor"
      />
    </svg>
  );
}

export function CodeIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 29 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.66667 1L1 8.66667L8.66667 16.3333M20.1667 1L27.8333 8.66667L20.1667 16.3333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Tool row context-menu icons (Define / Remove). Colors normalized to
// currentColor so each menu item's own `color` tints its icon. (Edit reuses
// the shared EntryIcon.)
export function DefineToolIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="currentColor" />
      <path
        d="M20 14H14M14 14H8M14 14V8M14 14V20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RemoveToolIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 29 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M28.5 5.44141H0.5M25.7544 9.55904L24.9967 20.9237C24.7052 25.295 24.5602 27.4807 23.1355 28.8131C21.7108 30.1456 19.5186 30.1472 15.1374 30.1472H13.8626C9.48141 30.1472 7.28918 30.1472 5.86447 28.8131C4.43976 27.4807 4.29318 25.295 4.00329 20.9237L3.24565 9.55904"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M5.44141 5.44117H5.62258C6.28544 5.42423 6.92775 5.20765 7.46552 4.81975C8.00328 4.43185 8.41147 3.8907 8.6367 3.26705L8.6927 3.09741L8.85247 2.61811C8.98917 2.208 9.05835 2.00376 9.14894 1.82917C9.32716 1.48723 9.58295 1.19175 9.89584 0.966378C10.2087 0.741008 10.57 0.592006 10.9508 0.531294C11.1435 0.5 11.3593 0.5 11.7908 0.5H17.2096C17.6412 0.5 17.8569 0.5 18.0496 0.531294C18.4304 0.592006 18.7917 0.741008 19.1046 0.966378C19.4175 1.19175 19.6733 1.48723 19.8515 1.82917C19.9421 2.00376 20.0113 2.208 20.148 2.61811L20.3078 3.09741C20.5165 3.79127 20.9482 4.39695 21.5359 4.82066C22.1237 5.24437 22.8348 5.46246 23.5591 5.44117"
        stroke="currentColor"
      />
    </svg>
  );
}

export function WarnIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="#F04248"
        fillOpacity="0.15"
        stroke="#F04248"
        strokeOpacity="0.5"
      />
      <path d="M10 5.5v5" stroke="#F04248" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="10" cy="14" r="1" fill="#F04248" />
    </svg>
  );
}

// On-screen keyboard keys — shift and backspace/delete glyphs.
export function ShiftIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.4494 4.34943C15.6481 4.13712 15.8884 3.96787 16.1552 3.85217C16.422 3.73646 16.7098 3.67676 17.0006 3.67676C17.2914 3.67676 17.5792 3.73646 17.846 3.85217C18.1128 3.96787 18.3531 4.13712 18.5519 4.34943L32.035 18.7357C33.31 20.0914 32.3452 22.3121 30.4837 22.3121H24.4381V28.6871C24.4381 29.2506 24.2142 29.7911 23.8157 30.1897C23.4172 30.5882 22.8767 30.8121 22.3131 30.8121H11.6881C11.1245 30.8121 10.584 30.5882 10.1855 30.1897C9.78699 29.7911 9.56311 29.2506 9.56311 28.6871V22.3121H3.51536C1.65811 22.3121 0.693359 20.0914 1.96411 18.7336L15.4494 4.34943ZM30.4859 20.1871L17.0006 5.80293L3.51536 20.1871H9.56311C10.1267 20.1871 10.6672 20.4109 11.0657 20.8095C11.4642 21.208 11.6881 21.7485 11.6881 22.3121V28.6871H22.3131V22.3121C22.3131 21.7485 22.537 21.208 22.9355 20.8095C23.334 20.4109 23.8745 20.1871 24.4381 20.1871H30.4859Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BackspaceIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M23.8945 22.239L27.825 26.1695C27.9884 26.3328 28.189 26.4203 28.427 26.432C28.665 26.4437 28.8774 26.3562 29.064 26.1695C29.2507 25.9828 29.344 25.7763 29.344 25.55C29.344 25.3237 29.2507 25.1172 29.064 24.9305L25.1335 21L29.064 17.0695C29.2274 16.9062 29.3149 16.7055 29.3265 16.4675C29.3382 16.2295 29.2507 16.0172 29.064 15.8305C28.8774 15.6438 28.6709 15.5505 28.4445 15.5505C28.2182 15.5505 28.0117 15.6438 27.825 15.8305L23.8945 19.761L19.964 15.8305C19.8007 15.6672 19.6 15.5797 19.362 15.568C19.1229 15.5563 18.9105 15.6438 18.725 15.8305C18.5384 16.0172 18.445 16.2237 18.445 16.45C18.445 16.6763 18.5384 16.8828 18.725 17.0695L22.6555 21L18.725 24.9305C18.5617 25.0938 18.4742 25.2951 18.4625 25.5342C18.4509 25.7711 18.5384 25.9828 18.725 26.1695C18.9117 26.3562 19.1182 26.4495 19.3445 26.4495C19.5709 26.4495 19.7774 26.3562 19.964 26.1695L23.8945 22.239ZM16.0528 33.25C15.6106 33.25 15.1865 33.1543 14.7805 32.963C14.3745 32.7705 14.0449 32.5004 13.7918 32.1527L6.55553 22.729C6.15653 22.2075 5.95703 21.6312 5.95703 21C5.95703 20.3688 6.15653 19.7925 6.55553 19.271L13.7918 9.84725C14.0449 9.49958 14.3745 9.23008 14.7805 9.03875C15.1865 8.84742 15.6106 8.75117 16.0528 8.75H33.9238C34.7054 8.75 35.3722 9.02533 35.924 9.576C36.4747 10.1267 36.75 10.794 36.75 11.578V30.4237C36.75 31.2054 36.4747 31.8722 35.924 32.424C35.3734 32.9747 34.7066 33.25 33.9238 33.25H16.0528ZM16.0528 31.5H33.9238C34.2376 31.5 34.4954 31.3991 34.6973 31.1973C34.8991 30.9954 35 30.7376 35 30.4237V11.5762C35 11.2624 34.8991 11.0046 34.6973 10.8027C34.4954 10.6009 34.2376 10.5 33.9238 10.5H16.0528C15.8731 10.5 15.7104 10.5338 15.5645 10.6015C15.4187 10.6692 15.2898 10.7701 15.1778 10.9042L7.94328 20.328C7.78578 20.5298 7.70703 20.7538 7.70703 21C7.70703 21.2462 7.7852 21.4708 7.94153 21.6737L15.1778 31.0957C15.2898 31.2311 15.4187 31.332 15.5645 31.3985C15.7104 31.465 15.8731 31.4988 16.0528 31.5Z"
        fill="currentColor"
      />
    </svg>
  );
}

// On-screen keyboard caret/history triangle — points up by default; rotate at
// the call site (0=up, 90=right, 180=down, 270=left).
export function ArrowTriangleIcon(props: IconProps): JSX.Element {
  return (
    <svg viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9561 0.186675C16.1562 -0.0622101 16.5352 -0.0622091 16.7353 0.186676L32.5791 19.8888C32.8422 20.216 32.6093 20.7021 32.1895 20.7021L0.501905 20.7022C0.0820615 20.7022 -0.150837 20.216 0.112267 19.8888L15.9561 0.186675Z"
        fill="currentColor"
      />
    </svg>
  );
}
